import React from 'react';
import { useFormikContext } from 'formik';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
interface QuillFormikProps {
  name: string;
}

const QuillFormik: React.FC<QuillFormikProps> = ({ name }) => {
  const { values, setFieldValue } = useFormikContext<any>();

  return (
    <div className='mt-10'>
        <h3 className="text-[20px] font-semibold mb-5">Content</h3>
      <ReactQuill
        value={values[name] || ''}
        onChange={(content:any) => setFieldValue(name, content)}
      />
    </div>
  );
};

export default QuillFormik;
